import { request } from "../../utils/config"

export const GET_FILTERED_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_FILTERED_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_FILTERED_RETURN_SALES_IS_DEFECTIVE = async (params) => {
  const response = await request({
    url: `ReturnSales/GetReturnSalesByFilter`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
    console.log(response.data)
  return response.data
}

export const GET_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
export const GET_RETURN_SALES_IS_DEFECTIVE = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  // Раньше строки отфильтровывались здесь, на клиенте, потому что сервер
  // не понимал параметр isDefective (в контроллере он назывался isDefect).
  // Из-за этого в «Браке» на странице оставалась часть строк, а счётчик
  // и пагинация приходили от сервера по нефильтрованной выборке.
  // Сервер фильтрует сам, клиентская фильтрация убрана.
  return response.data
}

export const GET_ALL_RETURN_SALES = async (params) => {
  const response = await request({
    url: `ReturnSales`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_RETURN_SALE = async (id) => {
  const response = await request({
    url: `ReturnSales/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

/**
 * Сколько этого товара продано контрагенту и по какой цене.
 * Формы «Возврат продажи» и «Брак» подставляют отсюда количество и цену,
 * чтобы оператор не искал их в продажах и не вводил руками.
 */
export const GET_SOLD_INFO = async (params: {
  counterpartyId: number
  productId: number
}) => {
  const response = await request({
    url: `Sales/SoldInfo`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
